import { service } from '@/common/request/request.js'

// 询直属列表
export function belongList(data = {}) {
  return service({
    url: '/userPromote/queryBelongList',
    method: 'post',
    data
  })
}

// 查询直属成员总数
export function BelongTotalInfo(data = {}) {
  return service({
    url: '/userPromote/queryBelongTotalInfo',
    method: 'post',
    data
  })
}

// 查询每日业绩
export function dailyPromote(data = {}) {
  return service({
    url: '/userPromote/queryDailyPromoteList',
    method: 'post',
    data
  })
}

// 查询我的业绩信息
export function myPromoteInfo(data = {}) {
  return service({
    url: '/userPromote/queryMyDailyPromoteInfo',
    method: 'post',
    data
  })
}

// 查询我的佣金派发记录
export function myPromoteRecord(data = {}) {
  return service({
    url: '/userPromote/queryMyPromoteGiftLogList',
    method: 'post',
    data
  })
}

// 查询我的团队信息
export function myTeamInfo(data = {}) {
  return service({
    url: '/userPromote/queryMyTeamInfo',
    method: 'post',
    data
  })
}

// 查询业绩推广等级
export function promoteLevel(data = {}) {
  return service({
    url: '/userPromote/queryPromoteLevelList',
    method: 'post',
    data
  })
}

// 查询团队列表
export function teamList(data = {}) {
  return service({
    url: '/userPromote/queryTeamList',
    method: 'post',
    data
  })
}

// 查询团队成员总数
export function teamTotalInfo(data = {}) {
  return service({
    url: '/userPromote/queryTeamTotalInfo',
    method: 'post',
    data
  })
}

// 提取我的佣金
export function drawMyPromote(data = {}) {
  return service({
    url: '/userPromote/withdrawMyPromoteAmount',
    method: 'post',
    data
  })
}

// inviteInfo
export function inviteInfo(data = {}) {
  return service({
    url: '/loged/inviteInfo',
    method: 'post',
    data
  })
}
// 邀请列表点击领取奖金按钮，领取奖金
export function getInviteBonus(data = {}) {
  return service({
    url: '/loged/getInviteBonus',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/common/api/team.js